import Checkbox from "../../../../components/Checkbox/Checkbox"
import { AnalysisControlsProps } from "./AnalysisControls.types"
import Dropdown from "../../../../components/Dropdown/Dropdown"
import "./AnalysisControls.css"

const AnalysisControls = (props: AnalysisControlsProps) => {

  const { 
    overlayCheckbox,
    disableOverlayCheckbox,
    showMaxCheckbox,
    showMinCheckbox,
    dataDisplayOptions,
    selectedDisplay,
    scanHeightDropdown,
    getProcessingVersion,
    onClickDataDisplayOption
   } = props

  return (
    <>
      <h2 className="analysis-control-title">Analysis</h2>

      <div className="data-display-options">
        {dataDisplayOptions.map((option, key) => (
          <p
            className={`data-display-option ${key === selectedDisplay ? "data-display-option-selected": ""}`}
            onClick={() => onClickDataDisplayOption(key)}
          >
            {option}
          </p>
        ))}
      </div>
      
      <Checkbox
        label="Show area of interest (Beta)"
        checkbox={overlayCheckbox}
        isLoading={false}
        enabled={!disableOverlayCheckbox}
      />

      <Checkbox 
        label="Highlight max"
        checkbox={showMaxCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Highlight min"
        checkbox={showMinCheckbox}
        isLoading={false}
      />
      <div className="scan-height-cotrols">
        <Dropdown
          label="Heatmap scan height"
          dropdown={scanHeightDropdown}
          isLoading={false}
        />
        <p>Heatmap scan height</p>
      </div>
      <p className="processed-version-text">{`Processing version: ${getProcessingVersion() ?? "loading..."}`}</p>
    </>
  )
}

export default AnalysisControls